<template>
  <div class="seriesView">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6" sm="6" class="text-left groupSelectSeries">
          <SelectSeries ref="selectSeries" />
        </v-col>

        <v-col cols="12" md="6" sm="12" class="text-left groupBtns">
          <v-btn class="ma-2 newseriesbtn" style="margin-right: .5rem !important;" @click="createSeries()">
            <v-icon left dark>fa-plus</v-icon>
            {{ $t('page.series.add-new-series') }}
          </v-btn>
          <v-btn class="ma-2" @click="publishSeries" v-if="seriesSelected && !seriesSelected.isPublishDisabled">
            <v-icon left dark>far fa-game-board</v-icon>
            {{ $t('page.series.publish-series-changes') }}
          </v-btn>
          <v-btn @click="confirmDelete()" dense elevation="1" class="text-center deleteSeries">
            <v-icon left dark>fas fa-trash</v-icon>
            {{ $t('common.form.delete_series') }}
          </v-btn>
        </v-col>

        <v-card v-if="seriesSelected != null" class="mx-auto" width="100%" outlined>
          <v-app-bar color="accent" dense elevation="0">
            <v-toolbar color="accent" dense elevation="0" class="forceHeightSmall">{{ $t('page.series.selected-series')
              }}: {{ seriesSelected.seriesName }}</v-toolbar>
          </v-app-bar>

          <v-card class="tabscard">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header color="secondary" class="text-customizer-accent">
                  {{ this.$t("page.series.expansion-panel.series-details") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br />
                  <SeriesDetails ref="seriesDetails" @loadEvent="loadEvent" @refreshRaces="refreshRaces" />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header color="secondary" class="text-customizer-accent">
                  {{ this.$t("page.series.expansion-panel.series-results") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br />
                  <SeriesResults ref="seriesResults" />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header color="secondary" class="text-customizer-accent">
                  {{ this.$t("page.series.expansion-panel.series-points") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br />
                  <SeriesPoints />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header color="secondary" class="text-customizer-accent">
                  {{ this.$t("page.series.expansion-panel.series-awards") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <br />
                  <SeriesAwards />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-card>
      </v-row>
    </v-container>

    <div id="seriesCP"></div>
    <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')"
      @cancel="dialogNotification = false;" @agree="destroySerie()" type="warning" :acept="$t('common.form.delete')"
      :reject="$t('common.form.cancel')" />
    <v-snackbar v-model="snackbar" timeout="3000" :color="color_snackbar">
      {{ msg_snackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          <v-icon>fas fa-times-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import SelectSeries from "@/components/series/SelectSeries.vue";
import SeriesDetails from "@/components/series/SeriesDetails.vue";
import SeriesResults from "@/components/series/SeriesResults.vue";
import SeriesPoints from "@/components/series/SeriesPoints.vue";
import SeriesAwards from "@/components/series/SeriesAwards.vue";
import { mapState } from "vuex";
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";

export default {
  mixins: [apiCalls],
  components: {
    SelectSeries,
    SeriesDetails,
    SeriesResults,
    SeriesPoints,
    SGSNotificationConfirm,
    SeriesAwards
  },
  data() {
    return {
      eventSelected: null,
      eventItems: [],
      dialogNotification: false,
      panel: [],
      tab: null,
      items: [{
        tab: "Series Details",
        content: "Tab 1 Content"
      },
      {
        tab: "Series Results",
        content: "Tab 2 Content"
      }
      ],
      serieName: null,
      displaySerieOnline: null,
      displaySerieOnlineItems: [{
        text: this.$t("page.series.display-series-online-items.yes"),
        value: "1"
      },
      {
        text: this.$t("page.series.display-series-online-items.no"),
        value: "0"
      }
      ],
      dateFrom: null,
      dateTo: null,
      menu: false,
      menu2: false,
      modal: false,
      snackbar: false,
      color_snackbar: '',
      msg_snackbar: '',
    };
  },
  created() {
    const d = new Date();
    const curYear = d.getFullYear();

    this.dateFrom = `${curYear}-01-01`;
    this.dateTo = `${curYear}-12-31`;
  },
  methods: {
    loadEvent(seriesId = null) {
      this.$refs.selectSeries.getSeries(seriesId);
    },
    async mfgReport() {
      let data = {
        seriesId: this.seriesSelected.id
      };

      //TODO: set the url
      const url = "";
      const response = await this.api("post", url, data);

      if (response != undefined) {
        //TODO: alert the user the record was saved
      }
    },
    async topTenReport() {
      let data = {
        seriesId: this.seriesSelected.id
      };

      //TODO: set the url
      const url = "";
      const response = await this.api("post", url, data);

      if (response != undefined) {
        //TODO: alert the user the record was saved
      }
    },
    confirmDelete() {
      this.dialogNotification = true;
    },
    async destroySerie() {
      let data = {
        seriesId: this.seriesSelected.id
      };
      const url = `/api/v1/promoter/series/${data.seriesId}`;
      const response = await this.api("delete", url, data);

      if (response != undefined) {
        this.dialogNotification = false;
        this.$refs.selectSeries.getSeries(null);
      }
    },
    async createSeries() {
      const data = {
        seriesName: this.$t("page.series.update-your-series-name")
      };

      const url = `/api/v1/promoter/series`;
      const response = await this.api("post", url, data);

      if (response != undefined) {
        this.dialogNotification = false;
        this.$refs.selectSeries.getSeries(response.seriesId);
      }
      this.panel = [0]
    },
    async publishSeries() {
      if (!this.userCurrent) {
        const getUserCurrent = await this.api("get", "/api/v1/users/current");
        this.userCurrent = getUserCurrent.message;
      }
      const result = await this.api(
        "post",
        "/api/v1/promoter/series/publishSeries",
        { seriesId: this.seriesSelected.id, userId: this.userCurrent.id });
      if (result.success) {
        this.msg_snackbar = this.$t('common.success');
        this.color_snackbar = 'success';
        this.snackbar = true;
      } else {
        this.msg_snackbar = this.$t('page.series.failed_publish');
        this.color_snackbar = 'error';
        this.snackbar = true;
      }
    },
    refreshRaces({ bandRaceList, newValues }) {
      if (this.$refs.seriesResults) {
        this.$refs.seriesResults.getRaceList(true, bandRaceList);
      } else {
        newValues.forEach((el) => {
          this.importScores(el);
        });
      }
    },
    async importScores(raceId) {
      const importResult = await this.api(
        "get",
        "/api/v1/promoter/series/import/" + raceId
      );
      const importSucceeded = importResult && (
        importResult.success === true ||
        importResult.success === 1 ||
        importResult.status === 'queued'
      );

      this.msg_snackbar = this.$t(
        importSucceeded ? 'common.success' : 'page.series.failed_import'
      );
      this.color_snackbar = importSucceeded ? 'success' : 'error';
      this.snackbar = true;
    },
  },
  computed: {
    ...mapState({
      seriesSelected: state => state.series.seriesSelected
    })
  }
};
</script>

<style scoped>
.orlbl {
  font-weight: bold;
  font-size: 14px;
  margin-right: 20px;
}

.newseriesbtn {
  margin-top: 0px !important;
}

.srs_fset {
  padding: 0.35em 0.625em 0.75em !important;
  margin: 5px !important;
  border: 1px solid var(--lighten-base) !important;
}

.srs_lgd {
  width: auto !important;
  font-size: 15px !important;
  border-bottom: none !important;
  margin-bottom: 0px !important;
}

.customlink {
  color: var(--v-primary-base);
  font-weight: bold;
  text-decoration: underline;
}

.tabscard {
  margin: 10px 5px;
}

.v-tab {
  text-transform: initial;
}
</style>

<style scss>
.dNot700 {
  display: none;
}

.forceHeightSmall {
  margin-left: .5rem;
}

.groupBtns .v-btn {
  margin-top: 0px !important;
}

@media (max-width: 959px) {
  .groupBtns {
    padding-top: 0px;
  }
}

@media (max-width: 700px) {
  .d700 {
    display: none;
  }

  .dNot700 {
    display: block;
  }

  .forceHeightSmall>div {
    min-height: 48px;
    height: auto !important;
  }

  .groupBtns .v-btn {
    margin-top: .5rem !important;
  }

  .groupSelectSeries,
  .groupSelectOthers {
    padding: 12px 12px calc(12px - .5rem);
  }

  .v-expansion-panel-content__wrap {
    padding-left: 0px;
    padding-right: 0px;
  }

  .seriesView .v-card__text {
    padding: 5px;
  }
}

@media (min-width: 1024px) {
  .breadcrumb-c {
    display: none !important;
  }
}

.v-dialog>.v-card>.v-card__actions {
  padding: 20px 16px;
}

.borderDialog {
  border: 1px solid;
  border-color: black !important;
}

@media (min-width: 712px) {
  .deleteSeries {
    float: right !important;
  }
}
</style>
